module.exports = __webpack_public_path__ + "static/img/v4_6.1740442d.png";